/* Heusom homepage v2 */
(function () {
  if (window.__hs2) return; window.__hs2 = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- toast ---------- */
  var toast;
  function showToast(msg) {
    if (!toast) {
      toast = document.createElement('div'); toast.className = 'hs2 hs2-toast'; toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.innerHTML = msg;
    toast.classList.add('is-on');
    clearTimeout(toast._t); toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 3800);
  }

  /* ---------- add to cart (opens theme cart drawer when available) ---------- */
  function addToCart(items, btn, msgEl) {
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.classList.add('is-loading'); btn.textContent = 'Adding…'; }
    if (msgEl) { msgEl.textContent = ''; msgEl.classList.remove('is-error'); }
    var drawer = $('cart-drawer');
    var body = { items: items };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
        var opened = false;
        if (drawer && typeof drawer.renderContents === 'function' && res.j.sections) {
          try {
            drawer.classList.remove('is-empty');
            var state = res.j.items ? Object.assign({}, res.j.items[0], { sections: res.j.sections }) : res.j;
            drawer.renderContents(state); opened = true;
          } catch (e) { opened = false; }
        }
        if (!opened) {
          if (res.j.sections && res.j.sections['cart-icon-bubble']) {
            var bubble = $('#cart-icon-bubble');
            if (bubble) {
              var tmp = document.createElement('div'); tmp.innerHTML = res.j.sections['cart-icon-bubble'];
              var inner = tmp.querySelector('.shopify-section') || tmp; bubble.innerHTML = inner.innerHTML;
            }
          }
          showToast('Added to cart ✓ <a href="' + (window.routes && routes.cart_url ? routes.cart_url : '/cart') + '">View cart →</a>');
        }
        if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-done'); btn.textContent = 'Added ✓'; setTimeout(function () { btn.classList.remove('is-done'); btn.innerHTML = label; }, 2200); }
      })
      .catch(function (err) {
        if (btn) { btn.classList.remove('is-loading'); btn.innerHTML = label; }
        if (msgEl) { msgEl.textContent = err.message; msgEl.classList.add('is-error'); } else { showToast(err.message); }
      });
  }

  /* quick-add forms */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-hs2-add]');
    if (!f) return;
    e.preventDefault();
    var fd = new FormData(f);
    addToCart([{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }], f.querySelector('[type="submit"]'), f.querySelector('.hs2-msg'));
  });
  /* multi-item buttons (kits) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hs2-kit]');
    if (!b) return;
    e.preventDefault();
    var ids = String(b.getAttribute('data-hs2-kit')).split(',').filter(Boolean);
    addToCart(ids.map(function (id) { return { id: Number(id), quantity: 1 }; }), b, null);
  });

  /* variant pills -> update price inside the same [data-hs2-product] */
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r.matches || !r.matches('[data-hs2-variant]')) return;
    var root = r.closest('[data-hs2-product]'); if (!root) return;
    var now = $('[data-hs2-now]', root), was = $('[data-hs2-was]', root), off = $('[data-hs2-off]', root);
    if (now) now.textContent = r.dataset.price;
    if (was) { was.textContent = r.dataset.compare || ''; was.hidden = !r.dataset.compare; }
    if (off) { off.textContent = r.dataset.off ? 'Save ' + r.dataset.off + '%' : ''; off.hidden = !r.dataset.off; }
    var img = $('.hs2-card__media img', root);
    if (img && r.dataset.img) { img.removeAttribute('srcset'); img.src = r.dataset.img; }
  });

  function init(scope) {
    /* hero tabs */
    $$('[data-hs2-tabs]', scope).forEach(function (wrap) {
      if (wrap._hs2) return; wrap._hs2 = true;
      var tabs = $$('[role="tab"]', wrap), host = wrap.closest('[data-hs2-hero]');
      function select(t) {
        tabs.forEach(function (x) { var on = x === t; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1; var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on; });
        $$('[data-hs2-stage]', host).forEach(function (s) { s.hidden = s.getAttribute('data-hs2-stage') !== t.getAttribute('aria-controls'); });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length]; n.focus(); select(n);
        });
      });
    });

    /* tool finder */
    $$('[data-hs2-finder]', scope).forEach(function (f) {
      if (f._hs2) return; f._hs2 = true;
      var btns = $$('[data-hs2-choice]', f);
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
          $$('[data-hs2-result]', f).forEach(function (r) { r.hidden = r.getAttribute('data-hs2-result') !== b.getAttribute('data-hs2-choice'); });
        });
      });
    });

    /* reviews slider + read more */
    $$('[data-hs2-slider]', scope).forEach(function (s) {
      if (s._hs2) return; s._hs2 = true;
      var track = $('.hs2-rev', s);
      $$('[data-hs2-dir]', s).forEach(function (b) {
        b.addEventListener('click', function () {
          var card = track.firstElementChild; var w = card ? card.getBoundingClientRect().width + 20 : 300;
          track.scrollBy({ left: Number(b.getAttribute('data-hs2-dir')) * w, behavior: 'smooth' });
        });
      });
      $$('.hs2-quote', s).forEach(function (q) {
        var p = $('p', q), more = $('.hs2-quote__more', q);
        if (!more) return;
        requestAnimationFrame(function () { if (p.scrollHeight <= p.clientHeight + 2) more.hidden = true; });
        more.addEventListener('click', function () { var o = q.classList.toggle('is-open'); more.textContent = o ? 'Show less' : 'Read more'; });
      });
    });

    /* sticky bar shows after hero leaves view */
    $$('[data-hs2-sticky]', scope).forEach(function (bar) {
      if (bar._hs2) return; bar._hs2 = true;
      var hero = $('[data-hs2-hero]'); var foot = $('[data-hs2-cta]');
      if (!('IntersectionObserver' in window)) return;
      var heroOut = false, footIn = false;
      function upd() { bar.classList.toggle('is-on', heroOut && !footIn); }
      if (hero) new IntersectionObserver(function (en) { heroOut = !en[0].isIntersecting; upd(); }).observe(hero); else heroOut = true;
      if (foot) new IntersectionObserver(function (en) { footIn = en[0].isIntersecting; upd(); }).observe(foot);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
